module.exports = __webpack_public_path__ + "img/Profiles.0f2846a6.svg";